'use client'

import { Phone, Clock } from 'lucide-react'
import {
  BAKERY_PHONE_HREF,
  BAKERY_PHONE_DISPLAY,
  BAKERY_HOURS_TEXT,
} from '@/lib/bakery'

/**
 * "Max online" banner for large orders. Appears the moment the chosen
 * quantity reaches the product's online ceiling: the webshop won't go higher,
 * and we invite a quick phone call for larger amounts, with a tap-to-call
 * link for mobile.
 */
export default function BulkOrderNotice({
  quantity,
  maxOnlineQty,
  phoneHref = BAKERY_PHONE_HREF,
  phoneDisplay = BAKERY_PHONE_DISPLAY,
  size = 'md',
}: {
  quantity: number
  maxOnlineQty: number
  phoneHref?: string
  phoneDisplay?: string
  size?: 'sm' | 'md'
}) {
  if (quantity < maxOnlineQty) return null

  const compact = size === 'sm'

  return (
    <div
      className={`rounded-xl ${compact ? 'px-3 py-2.5' : 'px-4 py-3.5'}`}
      style={{ background: '#FEF3E8', border: '1.5px solid #F4A460' }}
      role="status"
    >
      <div className="flex items-start gap-2.5">
        <div
          className="shrink-0 flex items-center justify-center rounded-lg"
          style={{ width: compact ? 28 : 34, height: compact ? 28 : 34, background: '#8B4513' }}
        >
          <Phone size={compact ? 14 : 17} color="#fff" />
        </div>
        <div className="min-w-0">
          <p className={`font-bold text-[#2C1810] ${compact ? 'text-xs' : 'text-sm'}`}>
            {maxOnlineQty} is het maximum dat u online kunt bestellen
          </p>
          <p className={`text-[#8B6B4A] ${compact ? 'text-[11px] mt-0.5' : 'text-xs mt-1'} leading-snug`}>
            Wilt u er meer? Bel ons even, dan kijken we wat we voor u kunnen maken.
          </p>

          <div className={`flex flex-wrap items-center gap-x-4 gap-y-1 ${compact ? 'mt-1.5' : 'mt-2.5'}`}>
            <a
              href={`tel:${phoneHref}`}
              className={`inline-flex items-center gap-1.5 font-bold text-[#8B4513] hover:text-[#D2691E] transition-colors ${compact ? 'text-xs' : 'text-sm'}`}
            >
              <Phone size={compact ? 12 : 14} />
              {phoneDisplay}
            </a>
            <span className={`inline-flex items-center gap-1.5 text-[#8B6B4A] ${compact ? 'text-[11px]' : 'text-xs'}`}>
              <Clock size={compact ? 11 : 13} />
              {BAKERY_HOURS_TEXT}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
